import * as FwDatas from "../FwDatas.ts";
import * as Html from "../util/Html.ts";
import * as actionMenu from  "../widget/action-menu-registry.ts"
import {TaskListCache} from "../server/objects/TaskBeans.ts"
import { getEndOfDay } from "../lib/DateUtils.ts";
import * as modal from "../util/modal.ts";
import { TaskInputBean } from "../server/fizapilib.auto.ts";

actionMenu.register({
  taskduedatepick(){
    var
      node = this,
      input = this.closest('form').dueDate;

    return {
      pickdate:{
        date:new Date(),
        onpickdate(date){
          var endOfDay = getEndOfDay(date);
          input.value = new Date(endOfDay.getTime()-3600000).toISOString();
          node.classList.add('color-branded')
        }
      }
    }
  },
  taskcategorypick(){
    var
      node = this,
      metaId = Html.getDomMetaId(this),
      input = this.closest('form').taskCategoryId,
      categories = TaskListCache.get(metaId).getCategories(true),
      buttons :actionMenu.ActionMenuButton[] = [{
        clickFunction(){
          input.value = '';
          node.classList.remove('color-branded')
        },
        emoji:'🏷️',
        selected:''==input.value,
        i18nkey:'catsystem.uncategorized'
      }];

    categories.forEach(category=>{
      buttons.push({
        clickFunction(){
          input.value = category.metaId;
          node.classList.add('color-branded')
        },
        emoji:category.emoji,
        selected:category.metaId==input.value,
        i18nkey:category.name
      })
    });

    return {
      menu:buttons
    }
  },
  taskassigneepick(){
    var
      node = this,
      input = this.closest('form').assignee,
      metaId = Html.getDomMetaId(this),
      members = TaskListCache.get(metaId).members.filter(m=>m.shared),
      buttons = [];

    members.forEach(member=>{
      buttons.push({
        clickFunction(){
          input.value = member.accountId;
          node.classList.add('color-branded')
        },
        iconclass:"fw-avatar fw-avatar-sizeXS",
        img:member.medias[0].pictureUrl,
        selected:member.accountId==input.value, // == because one is Long the other is String
        title:member.name
      })
    });

    return {'menu':buttons}
  }
});

type QuickAddForm = HTMLFormElement & {
  taskListId : HTMLInputElement
  assignee : HTMLInputElement
  taskCategoryId : HTMLInputElement
  dueDate : HTMLInputElement
  text : HTMLInputElement
  picture : HTMLInputElement
  
}
Html.registerDom({
  async taskquickaddswitchfull(){
    const
      taskListId = Html.getDomMetaId(this),
      form = this.closest('form') as QuickAddForm,
      TPL = await import("../modal/task_edit.mustache"),
      text = form.text.value,
      assignee = form.assignee.value,
      taskCategoryId = form.taskCategoryId.value,
      dueDate = form.dueDate.value==='$empty'?undefined:form.dueDate.value,
      customFiles = form.picture.customFiles,

      task = new TaskInputBean({
        text,
        recurrency:'NONE',
        dueDate,
        taskCategoryId,
        taskListId
      });
    const
      theModal = modal.openDomModal(TPL,{task});

    setTimeout(()=>{
      if(customFiles){
        const newInputFile = theModal.querySelector('[name=picture]') as HTMLInputElement;

        newInputFile.customFiles = customFiles
        newInputFile.dispatchEvent(new Event('change'));
      }
      if(assignee!=='$empty'){
        theModal.querySelector(`[data-accountid="${assignee}"]`)?.dispatchEvent(new Event('click'));
      }
    },100)



  }
})


Html.registerWidget('list/taskQuickAdd',{initDom})

function initDom(dom : HTMLElement){
  var
    input = dom.querySelector('input[name="text"]');


  input.addEventListener('focus',function(){
    dom.querySelectorAll<HTMLElement>('icon').forEach(icon=>icon.style.display='block')
  })
}
